var exports = {
  "zr": "x804f0401--37e2c4--root",
  "tg": "x804f0401--37e2c4--root_without-marks",
  "DD": "x804f0401--37e2c4--title",
  "Ft": "x804f0401--37e2c4--title_only-title",
  "e": "x804f0401--37e2c4--text-container",
  "Qq": "x804f0401--37e2c4--text",
};

module.exports = exports;
